import * as actions from "../actions/"
import {toast} from "react-toastify"

const defaultState = {
  deposits: [],
  deposit: null,
  verifications: [],
  fetching: false,
  fetched: false,
  error: null,
}

export default function reducer(state = defaultState, action) {

  switch (action.type) {
    // Listing deposits
    case actions.FETCH_DEPOSITS.PENDING: {
      return {...state, fetching: true}
    }
    case actions.FETCH_DEPOSITS.ERROR: {
      toast.error(action.payload.response.data.message);
      return {...state, fetching: false, error: action.payload}
    }
    case actions.FETCH_DEPOSITS.SUCCESS: {
      return {
        ...state,
        fetching: false,
        deposits: action.payload.data,
        pages: action.payload.pages,
      }
    }

    // Fetch single deposit
    case actions.FETCH_DEPOSIT.PENDING: {
      return {...state, deposit: {}, verifications:[], fetching: true}
    }
    case actions.FETCH_DEPOSIT.ERROR: {
      toast.error(action.payload.response.data.message);
      return {...state, fetching: false, error: action.payload}
    }
    case actions.FETCH_DEPOSIT.SUCCESS: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        verifications: [...action.payload.verifications],
        deposit: {...action.payload},
      }
    }

    // Listing verifications of a deposit
    case actions.FETCH_VERIFICATIONS.PENDING: {
      return {...state, fetching: true, verifications: []}
    }
    case actions.FETCH_VERIFICATIONS.ERROR: {
      return {...state, fetching: false, error: action.payload}
    }
    case actions.FETCH_VERIFICATIONS.SUCCESS: {
      return {
        ...state,
        fetching: false,
        verifications: action.payload
      }
    }
  }

  return state
}


// WEBPACK FOOTER //
// ./src/reducers/depositReducer.js